<template>
  <qx-card-form title="归属车队">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '车队名称',
            value: 'tenantName',
            type: 'show',
          },
          {
            label: '联系电话',
            value: 'tennantLinkPhone',
            type: 'show',
          },
        ],
      },
    };
  },
  methods: {
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        tenantName: res.tenantName,
        tennantLinkPhone: res.tennantLinkPhone,
      };
      return res;
    },

    async sub () {
      return {};
    },
    init (data) {
      this.$refs.baseForm.setVal('tenantName', data.tenantName);
      this.$refs.baseForm.setVal('tennantLinkPhone', data.tennantLinkPhone);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
